import React from "react";
import { Link } from "react-router-dom";
import StyledImage from "../../../shared/StyledImage";
import { ArrowRightMD, ArrowRightSM, Chevron, ChevronRight, substring } from "../../normalizer";
import CustomButton from "../../shared/CustomButton";

const months = ["jan.", "fev.", "mar.", "abr.", "mai.", "jun.",
                  "jul.", "ago.", "set.", "out.", "nov.", "dez."];


const PromotionCard = ({ content, limitText, imageSize, title }) => {
  const dateLabel = `${new Date(content.created_at).getDate()} ${months[new Date(content.created_at).getMonth()]}`;
  let size = "square_thumbnail_image";
  let normlimitText = limitText;
  if ("square_thumbnail_image" === imageSize) {
    normlimitText = 60;
  } else if (
    !["banner_desktop_image", "banner_desktop_image"].includes(imageSize)
  ) {
    size = "square_thumbnail_image";
  }

  const croppedImageKey = size.replace("image", "cropped_image");

  const image =
    content.image[croppedImageKey] && content.image[croppedImageKey].url
      ? content.image[croppedImageKey].url
      : content.image[size]
      ? content.image[size].url
      : "";

  return (
    <div className="promotion-card">
      <img className="promotion-card-image" src={image} alt=""/>
      <div className="promotion-card-container">
        <label className="promotion-card-date">
          {dateLabel}
        </label>
        <label className="promotion-card-header">
          {title ? title : "Novidade!"}
        </label>
        <div className="promotion-card-title">{content.title}</div>
        <div className="promotion-card-content">
          <p className="promotion-card-content-text">{substring(content.subtitle, normlimitText, "...")}</p>
          <CustomButton className="promotion-card-content-link" link tight to={"/news/" + content.id}>
            Saiba mais
            <ArrowRightSM />
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default PromotionCard;
